

<mat-dialog-content class="custom-dialog-container">
  <div *ngIf="uploadProgress > 0">
    <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
  </div>
  <div>
    <h2>Adicione imagens para seu produto </h2>   
      <div class="image-selector">
        <div *ngFor="let iconName of iconList; let i = index" class="icon-container">
          <div class="icon-wrapper" (click)="selectIcon(i)">
            <img  *ngIf="!selectedImages[i]" [src]="image" class="custom-image" alt="Icon Image">
            <input *ngIf="!selectedImages[i]" type="file" class="upload-input" (change)="uploadImage($event, i)">
          </div>
          <div *ngIf="selectedImages[i]" class="image-preview">
            <img [src]="selectedImages[i]" alt="Selected Image">
            <div class="button-container">              
              <button color="warn" mat-raised-button (click)="removeImage(i)"  class="small-button removeButton">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </div>
        </div>  
      </div>      
  </div>
</mat-dialog-content>

<mat-dialog-actions class="mat-actions">
  <button mat-raised-button color="warn" mat-dialog-close>CANCELAR</button>
  <button mat-raised-button color="primary" (click)="uploadToS3()">OK</button>
</mat-dialog-actions>
